export default __webpack_public_path__ + "static/media/Support_&_Maintenance.aa44548e.png";